import { handleActions } from 'redux-actions';

import { getLogger } from 'companion-app-components/utils/core';
import { resourceStoreTypes, resourceUpserters } from 'companion-app-components/flux/core';
import { 
  categoryGroupsReducer as componentCategoryGroupsReducer,
  CATEGORY_GROUPS_REDUCER_KEY as REDUCER_KEY, 
} from 'companion-app-components/flux/category-groups';
import { CategoryGroupsProps } from 'companion-app-components/flux/category-groups/categoryGroupsTypes';

import * as actions from './categoryGroupsActions';

const log = getLogger('data/categoryGroups/categoryGroupsReducer.js');

const categoryGroupsStoreFactory =
  resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<CategoryGroupsProps>();


const categoryGroupsReducer = handleActions<
resourceStoreTypes.QcsSyncResourceStore<CategoryGroupsProps>,
| ReturnType<typeof actions.createCategoryGroupsAction>
| ReturnType<typeof actions.createCategoryGroupsSuccessAction>
| ReturnType<typeof actions.createCategoryGroupsFailureAction>
>({
  [actions.createCategoryGroupsAction.type]: (state) => {
    log.log('createCategoryGroupsAction...');
    return state.merge({ isLoading: true });
  },
  [actions.createCategoryGroupsSuccessAction.type]: (state, { payload }) => {
    log.log('createCategoryGroupsSuccessAction...\n', payload);
    return resourceUpserters.upsertResources(state, payload);
  },
  [actions.createCategoryGroupsFailureAction.type]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),

}, categoryGroupsStoreFactory());

// chain reducers
export const categoryGroupReducerChain = (state, action) => (componentCategoryGroupsReducer(
  categoryGroupsReducer(state, action), 
  action,
));

export const CATEGORY_GROUPS_REDUCER_KEY = REDUCER_KEY;

export default categoryGroupReducerChain;
